module.exports = __webpack_public_path__ + "static/media/1.4 Nachtlandschaft nach Rahmen_klein.143bbe91.jpg";